import { EventEmitter, Injectable, ElementRef } from '@angular/core';
import Swal from 'sweetalert2'
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor() { }

  openSimpleAlert(type: any, message: any, duration: number = 3500) {
    Swal.fire({
      position: "top",
      icon: type,
      title: message,
      showConfirmButton: duration === 0,
      timer: duration > 0 ? duration : undefined
    });
  }

  openSimpleTitleAlert(type: any, title: any, message: any,) {
    Swal.fire({
      position: "center",
      title: title,
      html: message,
      icon: type
    });
  }



  setWarning(ref: any, msg: string): void {
    this.openSimpleAlert('warning', msg);
    if (ref && ref.nativeElement) {
      ref.nativeElement.classList.add('warning');
    }
  }

  clearWarning(ref: any): void {
    if (ref && ref.nativeElement) {
      ref.nativeElement.classList.remove('warning');
    }
  }

  /**
   * Muestra un popup de confirmación con botones personalizados.
   * @param title Título del popup
   * @param message Mensaje del popup
   * @param confirmText Texto del botón de confirmar
   * @param cancelText Texto del botón de cancelar
   * @param onConfirm Función a ejecutar si se confirma
   */
  openConfirmationAlert(
    title: string,
    message: string,
    confirmText: string,
    cancelText: string,
    onConfirm: () => boolean | Promise<boolean>
  ): void {
    Swal.fire({
      title: title,
      html: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        const shouldShowSuccess = await onConfirm(); // <- importante
        if (shouldShowSuccess) {
          Swal.fire({
            icon: 'success',
            title: 'Infracción creada correctamente',
            timer: 2500,
            showConfirmButton: false
          });
        }
      }
    });
  }

  /**
 * Muestra un popup con un textarea para ingresar motivos de eliminación.
 * @param title Título del popup
 * @param placeholder Placeholder del textarea
 * @param confirmText Texto del botón de confirmar
 * @param cancelText Texto del botón de cancelar
 * @param onConfirm Función que se ejecuta si se confirma, recibe el motivo ingresado
 */
  openReasonPrompt(
    title: string,
    placeholder: string,
    confirmText: string,
    cancelText: string,
    onConfirm: (reason: string) => void,
    warningMessage: string = '',
  ): void {
    Swal.fire({
      title: title,
      html: `
      ${warningMessage ? `<p class="swal2-warning-message">${warningMessage}</p>` : ''}
      <textarea id="reason-textarea" class="swal2-textarea" placeholder="${placeholder}" rows="5" style="margin: 0px; width: 100%"></textarea>
    `,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      preConfirm: () => {
        const reason = (document.getElementById('reason-textarea') as HTMLTextAreaElement).value.trim();
        if (!reason) {
          Swal.showValidationMessage('Debe escribir un motivo');
          return false;
        }
        return reason;
      },
      focusConfirm: false,
      customClass: {
        popup: 'custom-swal-popup'
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        onConfirm(result.value);
      }
    });
  }


  /**
    * Muestra un popup con una lista de opciones para que el usuario seleccione una.
    * Este método es ideal para cuando necesitas que el usuario elija UN elemento de una lista.
    * @param title Título del popup.
    * @param message Mensaje descriptivo para el usuario.
    * @param options Un array de objetos { value: string | number, label: string } para las opciones a mostrar.
    * @returns Una Promesa que resuelve con el 'value' de la opción seleccionada, o null si se cancela.
    */
  openSelectionDialog(
    title: string,
    message: string,
    options: { value: string | number; label: string }[]
  ): Promise<any | null> {
    // Transforma el array de opciones a un objeto que SweetAlert2 puede usar para 'inputOptions'.
    // Las claves deben ser strings, por eso usamos .toString().
    const inputOptions = options.reduce((acc: { [key: string]: string }, option) => {
      acc[option.value.toString()] = option.label;
      return acc;
    }, {} as { [key: string]: string });

    return Swal.fire({
      title: title,
      html: message,
      icon: 'question', // Puedes usar 'info', 'question', 'warning' según el contexto.
      input: 'select',  // Esto le dice a SweetAlert2 que cree un desplegable (select).
      inputOptions: inputOptions, // Las opciones para el desplegable.
      inputPlaceholder: 'Seleccione una categoría', // Texto por defecto en el desplegable.
      confirmButtonText: 'Confirmar',
      reverseButtons: true,
      // Una pequeña validación para asegurar que el usuario elija algo.
      inputValidator: (value) => {
        if (!value) {
          return '¡Debe seleccionar una opción para continuar!';
        }
        return null; // Validación exitosa
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // Si el usuario confirmó la selección, retorna el valor elegido.
        return result.value;
      }
    });
  }
}
